<tc-cg-season-calendar
        [fromYear]="fromYear"
        [toYear]="toYear"
        [rangeGroups]="rangeGroupsForSeasonCalendar"
        (onChangeSeasons)="onChangeSeasons($event)">
</tc-cg-season-calendar>
